package com.evoapps.evoshift.data.mapper

import com.evoapps.evoshift.data.dto.workplace.WorkplaceFinancialsDto
import com.evoapps.evoshift.domain.model.WorkplaceFinancials

class WorkplaceFinancialsMapper {
    fun toDomain(dto: WorkplaceFinancialsDto): WorkplaceFinancials {
        // SH-95: a target saved before as a share of net sales becomes a share of income on
        // reading (÷ the commission); the document keeps it until the settings are saved again.
        val stored = dto.labourTargetPercent
        val legacy = stored != null && dto.labourTargetBase != WorkplaceFinancialsDto.LABOUR_TARGET_BASE_INCOME &&
            dto.commissionPercent > 0
        return WorkplaceFinancials(
            fixedRevenueMonthly = dto.fixedRevenueMonthly,
            commissionPercent = dto.commissionPercent,
            includeFixedRevenueInDailyFinancialReport = dto.includeFixedRevenueInDailyFinancialReport,
            salesTargets = dto.salesTargets,
            labourTargetPercent = if (legacy && stored != null) {
                WorkplaceFinancials.labourTargetFromSales(stored, dto.commissionPercent)
            } else {
                stored
            },
            labourTargetConvertedFromSales = stored.takeIf { legacy },
            salesPerLabourHourGoal = dto.salesPerLabourHourGoal?.takeIf { it > 0 }
        )
    }

    fun toDto(domain: WorkplaceFinancials): WorkplaceFinancialsDto {
        return WorkplaceFinancialsDto(
            fixedRevenueMonthly = domain.fixedRevenueMonthly,
            commissionPercent = domain.commissionPercent,
            includeFixedRevenueInDailyFinancialReport = domain.includeFixedRevenueInDailyFinancialReport,
            salesTargets = domain.salesTargets,
            labourTargetPercent = domain.labourTargetPercent,
            labourTargetBase = domain.labourTargetPercent?.let { WorkplaceFinancialsDto.LABOUR_TARGET_BASE_INCOME },
            salesPerLabourHourGoal = domain.salesPerLabourHourGoal
        )
    }
}
